import { render, staticRenderFns } from "./VoteGuide.vue?vue&type=template&id=54520670&"
import script from "./VoteGuide.vue?vue&type=script&lang=js&"
export * from "./VoteGuide.vue?vue&type=script&lang=js&"
import style0 from "./VoteGuide.vue?vue&type=style&index=0&id=54520670&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports